import React from 'react';
import { ContractEndDiv } from '../component/contract-end/ContractEndDiv';
import { MainNavigationBar } from '../component/navigation-bar/MainNavigationBar';
import { GeneralPageLayout } from '../layout/GeneralPageLayout';

export const ContractEndPage = () => (
  <GeneralPageLayout
    navigationBar={<MainNavigationBar />}
    elementCentr={<ContractEndDiv />}
  />
);
